import IAjaxConnect from "./IAjaxConnect";
import {wait} from "../../helpers";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import SystemConfig, {CONFIG_PARAMS, GAMECONF_PARAMS} from "../../system/SystemConfig";
import {injectable} from "inversify";
import IDOM from "../../ui/IDOM";
import MadmaxError, {errorFactroy} from "../../error/MadmaxError";
import {getCustomError} from "../../error/EasitError";
import {FETCH_TYPES} from "../Connect";

@injectable()
export default abstract class AbstractConnect implements IAjaxConnect {
    abstract readonly fetchType: string;
    protected method;

    timeout: number;
    isSilentClose: boolean = true;

    protected fetchModule: FetchAjax;
    protected control: IConnectControl;
    protected config: SystemConfig;
    protected dom;

    protected data: Record<string, any> = {};

    protected ajaxLoadingTimer: number;
    protected ajaxLoadingTimeout: number;

    protected constructor(config: SystemConfig, control: IConnectControl, fetchModule: FetchAjax, dom: IDOM) {
        this.config = config;
        this.fetchModule = fetchModule;
        this.control = control;
        this.dom = dom;

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).default > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).default * 1000;
        } else {
            this.timeout = 20000;
            this.ajaxLoadingTimeout = this.timeout /9
        }
    }

    protected getDelay(timeout, lastFetchTime = null) {

        if(lastFetchTime == null) {
            return 0;
        }

        let delay = timeout - (Date.now() - lastFetchTime);
        if(delay < 0) delay = 0;

        return delay
    }

    protected async _fetch(): Promise<any> {

        let lastFetchTime = Date.now();

        try {

            let res = await this.fetchModule.fetch({url: this.getUrl(), params: this.getParams(), timeout: this.timeout, method: this.method });

            this.stopTimeoutLoading();

            // playtech custom error messages
            if (res && res.data && res.data.popup_messages) {
                getCustomError(res, this.dom, this.config);
            }

            return res;

        } catch (error) {
            let data;

            try {
                data = await this.control.control(error, this.fetchType, this.data);
            } catch (madmaxError) {

                this.stopTimeoutLoading();

                return await Promise.reject(madmaxError);
            }

            let delay = this.getDelay(this.timeout, lastFetchTime);

            if(data) {
                if (data["$delayms"]) {
                    delay = data["$delayms"];
                    delete data["$delayms"];
                }
                this.data = data;
            }

            if(delay) await wait(delay);

            return await this._fetch();
        }
    }

    protected initTimeoutLoading() {
        this.ajaxLoadingTimer = setTimeout(() => {
            this.dom.ajaxLoading.showLoading();
        }, this.ajaxLoadingTimeout);
    }

    protected stopTimeoutLoading() {
        clearTimeout(this.ajaxLoadingTimer);
        this.dom.ajaxLoading.hideLoading();
    }

    protected setMethod(newMethod: string) {
        this.method = newMethod;
    }

    public abstract fetch(data?: {}): Promise<any>;
    protected abstract getParams(): Record<string, any>;
    protected abstract getUrl(): string;
}